angular.module('salesPath2')
  .controller('clientSearchCtrl', ['$scope', 'availabilityHelper', 'navigationHelper', 'personHelper', 'clientAddHelper', 'ceidgModalHelper', 'dataContainerHelper', '$timeout', 'CONFIG', 'actionHelper', '$document', '$q',
    function($scope, availabilityHelper, navigationHelper, personHelper, clientAddHelper, ceidgModalHelper, dataContainerHelper, $timeout, CONFIG, actionHelper, $document, $q) {
      $scope.dictAvailable = availabilityHelper.isAvailable('addressSearch');      
      /**
       * obiekt wykorzystywany w autocompleterze clientSearch
       * @type {Object}
       */
      $scope.temp = {
        search: ''
      };
      $scope.clientSearchViewData = {
        loadingElements: false
      };
      $scope.dictAvailable = availabilityHelper.isAvailable('addressSearch');

      $scope.apk = dataContainerHelper.getApk();
      
      /**
      * nasluchuje na akcje actionHelpera
      * @type {Object}
      */
      $scope.clientSearchListener = {
       /**
        * reakcja na akcje w aplikacji
        * @param  {String} actionName nazwa wykonanej akcji
        */
       _afterAction: function(actionName) {
         if (actionName === 'apkDetailsSet' || actionName === 'apkTabChanged') {  
          $scope.setSearchFromApk();
         }
       }
      };

      $scope.init = function() {
        actionHelper.registerHelper('clientSearchCtrl', $scope.clientSearchListener, [
          'apkDetailsSet', 'apkTabChanged'
        ]);
        $scope.setSearchFromApk();
      };

      $scope.setSearchFromApk = function() {
        $scope.apkDetails = dataContainerHelper.getApkDetails();
        $scope.temp.search = $scope.apkDetails.firstName && $scope.apkDetails.lastName ? $scope.apkDetails.firstName + ' ' + $scope.apkDetails.lastName : '';
        $timeout(function() {
          var input = $document.find('.clientTypeAhead');
          input.focus();
        }, 100);
      };

      /**
       * przejście do ekranu dodawania nowego klienta
       */
      $scope.goToClientEdit = function() {
        clientAddHelper.tplData.personData = null; //czyscimy ewentualne dane osoby
        navigationHelper.go($scope.CONSTANTS.PAGE_START_CLIENT_EDIT);
      };

      /**
       * sprawdzanie czy można wyszukac klienta w CEIDG
       * @return {Boolean}
       */
      $scope.isCeidgSearch = function() {
        return $scope.CONFIG.BEHAVIOR.ceidgSearch;
      };

      $scope.onSelect = function($item) {
        $scope.temp.search = ''; //resetujemy, ponieważ w tym momencie w search znajduje się obiekt osoby i widać to w inpucie
        personHelper.loadPerson($item.person.metaData.id, $item.person, function(personData) {
          clientAddHelper.tplData.personData = personData; //zasilamy kolejną stronę danymi osoby      
          personHelper._mapDynamicValuesToAdditionalData(clientAddHelper.tplData.personData);
          navigationHelper.go($scope.CONSTANTS.PAGE_START_CLIENT_EDIT);
        });
      };

      /**
       * wywołanie modala dodawania CEIDG
       */
      $scope.showCeidgModal = function() {
        ceidgModalHelper.openSearchCeidgClientModal();
      };
      
      if ($scope.dictAvailable) {

        $scope.findPersons = function(val) {
          return $q(function(resolve){
            $scope.clientSearchViewData.loadingElements = true;
            var persons = personHelper.findPersons(val);
            var obj = [];
            if (angular.isFunction(persons.then)) {
              persons.then(function(items) {
                personHelper.filterPersonsAdded(items, $scope.dataContainer.persons);

                var showNip = false;
                if (CONFIG.BEHAVIOR.mainInsuredAdditionalFields.indexOf('NIP') !== -1) {
                  showNip = true;
                }

                angular.forEach(items, function(person) {
                  person.addressInOneString = personHelper.personAddressToOneString(person);
                  obj.push({
                    person: person,
                    showNip: showNip
                  });
                });
                resolve(obj);
              }, function(){
                resolve();
              }).finally(function(){
                $scope.clientSearchViewData.loadingElements = false;
              });
            } else {
              $scope.clientSearchViewData.loadingElements = false;
              resolve();
            }
          });


        };

      }

      $scope.init();
    }
  ]);